import React, { useState, useEffect, useCallback, useContext } from 'react';
import { TenantContext } from '../../tenant/TenantContext';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { FormField } from 'uiwidgets/FormField';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { API } from '../../api/API';
import { BUSINESS_PROMOTIONS } from '../../config/config';
import { extractError } from '../../api/ErrorUtil';
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTruckArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { PAGE_SIZE } from '../../config/config';
import { containsAlphaNumAndSpaceAndPunctuationOnly } from 'util/Validators';


const BusinessPromotions = () => {

    const initialState = {
        errors: {},
        infoMessage: ""
    }
    const { businessConfig } = useContext(TenantContext);
    let [promotions, setPromotions] = useState([]);
    let [formData, setFormData] = useState(initialState);
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState(0);

    const [currentPage, setCurrentPage] = useState(0);
    const [totalNumberOfPages, setTotalNumberOfPages] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [filterValidityData, setFilterValidityData] = useState({
        keywordErrMsg: "", keywordError: false
    });


    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }

    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const fetchPromotions = useCallback(async () => {
        try {
            let promotionsResponse = await API.get(BUSINESS_PROMOTIONS, {
                params: {
                    size: PAGE_SIZE,
                    page: currentPage,
                    keyword: keyword.trim(),
                }
            });
            let promotions = promotionsResponse.data.content
            let totalNumberOfPages = promotionsResponse.data.totalPages;

            setPromotions(promotions);
            setTotalNumberOfPages(totalNumberOfPages);

        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setPromotions([]);
                setFormData({ ...formData, infoMessage: "No promotions were found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }

    })

    useEffect(() => {
        fetchPromotions();
    }, []);

    useEffect(() => {
        fetchPromotions();
    }, [refresh]);


    const handlePaging = async (page) => {
        if (page < 0) {
            alert("Reached the beginning of data set")
            page = 0;
        }
        if (page > totalNumberOfPages - 1) {
            alert("Reached the end of data set")
            page = totalNumberOfPages - 1;
        }
        setCurrentPage(page);
        setRefresh(Math.random);
    }

    const handleFilterKeyDown = async (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            setRefresh(Math.random);
        }
    };
    const clearFilter = async (event) => {
        setKeyword("");
        setCurrentPage(0);
        setRefresh(Math.random);
    };

    const handleFilterChange = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        if (name === 'keyword') {
            setKeyword(value)
        }
    }

    const handleFilterValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFilterValidityData({
            ...filterValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
          error = ""
    
        switch (name) {
          case "keyword":
            if (value.trim() === "") {
              hasError = false
              error = ""
            } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
              hasError = true
              error = "Invalid keyword. Only alphanumeric characters are allowed";
            } else {
              hasError = false
              error = ""
            }
            break
          default:
            break
        }
        return { hasError, error }
      }

    const createNewPromotion = async (event) => {
        event.preventDefault();
        navigate('/businesspromotion/newpromotion');
    }

    const editPromotion = async (event, promotion) => {
        event.preventDefault();
        navigate('/businesspromotion/' + promotion.promotionId);
    }

    const fulfilPromotion = async (event, promotion) => {
        event.preventDefault();
        navigate('/businesspromofulfilment/' + promotion.promotionId);
    }

    return (
        <FormContainer title="Promotions" toastCloseFunc={onToastClose} errors={formData.errors} infoMessage={formData.infoMessage} >
            <Row>
                <Col sm={12} md={4} lg={4}>
                    <Button label='New Promotion' onClick={createNewPromotion}
                        className={'btn-fill pull-right '} size='btn-sm' variant="info">New Promotion</Button>
                </Col>
                <Col sm={12} md={4} lg={4}>
                    <FormField name="keyword" label="Promotion Name" type="text" value={keyword}
                        placeholder="promotion name" onChange={handleFilterChange}
                        onBlur={handleFilterValidation} onKeyDown={handleFilterKeyDown}
                        valstate={!filterValidityData.keywordError} valMsg={filterValidityData.keywordErrMsg} />
                </Col>
                <Col sm={6} md={2} lg={2}>
                    <br />
                    <Button variant="info" className="border-0 btn-fill" onClick={clearFilter}><strong><small>Clear Filter</small></strong></Button>
                </Col>
            </Row>
            <Row>
                <Col className='d-flex justify-content-end'>
                    <Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage - 1) }}>
                        <h6><FontAwesomeIcon icon={faArrowLeft} onClick={(event) => { handlePaging(currentPage - 1) }} />Previous Page</h6>
                    </Button>
                    &nbsp;<span className="border-0 text-dark btn"><h6>{currentPage + 1} of {totalNumberOfPages}</h6></span>
                    &nbsp;<Button variant="dark" className="border-0 text-dark" onClick={(event) => { handlePaging(currentPage + 1) }}>
                        <h6>Next Page<FontAwesomeIcon icon={faArrowRight} /></h6>
                    </Button>
                </Col>

            </Row>
            <Row>

            </Row>
            <Table className="table-hover table-striped">
                <thead>
                    <tr>
                        <th className="border-0">Promotion Name</th>
                        <th className="border-0">Description</th>
                        <th className="border-0">Start Date</th>
                        <th className="border-0">End Date</th>
                        <th className="border-0">Edit</th>
                        <th className='border-0'>Fulfilment</th>
                    </tr>

                </thead>
                <tbody>
                    {promotions && !_.isEmpty(promotions) && promotions.map((promotion, idx) => (
                        <tr key={idx}>
                            <td>
                                {promotion.name}
                            </td>
                            <td>
                                {promotion.description}
                            </td>
                            <td>
                                {promotion.startDate}
                            </td>
                            <td>
                                {promotion.endDate}
                            </td>
                            <td>
                                <Button variant="dark" className="border-0 text-dark" onClick={evt => editPromotion(evt, promotion)}>
                                    <FontAwesomeIcon icon={faEdit} />
                                </Button>
                            </td>
                            <td>
                                <Button variant="dark" className="border-0 text-dark" onClick={evt => fulfilPromotion(evt, promotion)}>
                                    <FontAwesomeIcon icon={faTruckArrowRight} />
                                </Button>

                            </td>
                        </tr>
                    ))}

                </tbody>
            </Table>
        </FormContainer>
    )
}

export default BusinessPromotions